// extracted by mini-css-extract-plugin
module.exports = {"root":"mtun9b","title":"s_dbuV","controls":"Oj_T9b","slider":"CAFOud"};